import { Dialog, Portal } from '@chakra-ui/react'

export const Modal = ({ title, isOpen, onClose, footer = null, children, ...props }) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(e) => onClose(e.open)} {...props}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>{title}</Dialog.Title>
              <Dialog.CloseTrigger mt={1} />
            </Dialog.Header>
            <Dialog.Body>{children}</Dialog.Body>
            {footer && <Dialog.Footer zIndex={-1}>{footer}</Dialog.Footer>}
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
